import { OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { AccountInfoVm } from '../../models/accountInfo.vm';
import { AccountInfoService } from '../../services/account-info.service';

import { Component } from '@angular/core';

@Component({
  selector: 'app-base-account-info',
  template: '',
})
export abstract class BaseAccountInfoComponent implements OnInit, OnDestroy {
  accountInfo: AccountInfoVm | null = null;
  private accountInfoSubscription: Subscription;

  constructor(protected accountInfoService: AccountInfoService) {}

  ngOnInit(): void {
    // Subscribe to accountInfo$
    this.accountInfoSubscription =
      this.accountInfoService.accountInfo$.subscribe((accountInfo) => {
        this.accountInfo = accountInfo;
      });
  }

  ngOnDestroy(): void {
    // Unsubscribe to avoid memory leaks
    if (this.accountInfoSubscription) {
      this.accountInfoSubscription.unsubscribe();
    }
  }
}
